"use client";

import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";

import { supabaseEnv } from "@/lib/config";

/**
 * Browser-side Supabase client. Used from Client Components — the
 * /login form most prominently. Storage backend is the browser cookie
 * store, which means sessions are read by the server-side client on
 * the next request without any further wiring.
 */
let browserClient: SupabaseClient | null = null;

export function getSupabaseBrowserClient(): SupabaseClient {
  if (!browserClient) {
    browserClient = createBrowserClient(
      supabaseEnv.requireUrl(),
      supabaseEnv.requireAnonKey()
    );
  }
  return browserClient;
}
